import { enhancedApi } from '@store/generated/jotcoach';

/**
 * Feature-specific tag types for jotcoach
 */
const JOTCOACH_TAG_TYPES = ['JotCoachSession', 'JotCoachSessionList'] as const;

/**
 * JotCoach API - extends the generated API with custom tagging
 *
 * Note: The session-based SMS endpoints (getV2ProviderJotcoachSessions, admin endpoints, etc.)
 * have been removed from the backend. Only encounter-based analysis endpoints remain.
 */
export const jotcoachApi = enhancedApi.enhanceEndpoints({
  addTagTypes: JOTCOACH_TAG_TYPES,
  endpoints: {
    // Encounter session endpoints (for in-note analysis)
    getV2ProviderJotcoachEncounterSessions: {
      providesTags: result =>
        result
          ? [
              ...result.items.map(item => ({
                type: 'JotCoachSession' as const,
                id: `encounter-${item.encounter_id}`,
              })),
              { type: 'JotCoachSessionList' as const, id: 'ENCOUNTER_LIST' },
            ]
          : [{ type: 'JotCoachSessionList', id: 'ENCOUNTER_LIST' }],
    },
    getV2ProviderJotcoachEncounterSessionsByEncounterId: {
      providesTags: (_result, _error, arg) => [
        { type: 'JotCoachSession', id: `encounter-${arg.encounterId}` },
      ],
    },
  },
});

// Export hooks with user-friendly names
export const {
  // Encounter session endpoints (for in-note analysis)
  useGetV2ProviderJotcoachEncounterSessionsQuery: useGetJotCoachEncounterSessionsQuery,
  useGetV2ProviderJotcoachEncounterSessionsByEncounterIdQuery: useGetJotCoachEncounterSessionQuery,
  useLazyGetV2ProviderJotcoachEncounterSessionsByEncounterIdQuery: useLazyGetJotCoachEncounterSessionQuery,
  // Rules endpoint
  useGetV2ProviderJotcoachRulesQuery: useGetJotCoachRulesQuery,
} = jotcoachApi;
